import { store } from "store";
import { selectCartProduct } from "store/slices/cartSlice";

export function getCartProductById(productId: number) {
    const state = store.getState();
    return selectCartProduct(productId)(state);
}
